const locales = ['de', 'en', 'fr', 'pl', 'nl', 'ru']

const localesMap: {[key: string]: any} = {
    de: 'Deutsch',
    en: 'English',
    fr: 'Français',
    pl: 'Polski',
    nl: 'Nederlands',
    ru: 'Русский',
    it: 'Italiano'
}


const langselectorItems = [
    {
        id: 1,
        region: "DE",
        defaultLanguage: "de",
        countryName: "Germany",
        languages: ["de"],
        showInSelector: true
    },
    {
        id: 2,
        region: "FR",
        defaultLanguage: "fr",
        countryName: "France",
        languages: ["fr"],
        showInSelector: true
    },
    {
        id: 3,
        region: "NL",
        defaultLanguage: "nl",
        countryName: "Netherlands",
        languages: ["nl"],
        showInSelector: true
    },
    {
        id: 4,
        region: "CH",
        defaultLanguage: "de",
        countryName: "Switzerland",
        languages: ["de", "fr"],
        showInSelector: true
    },
    {
        id: 5,
        region: "AT",
        defaultLanguage: "de",
        countryName: "Austria",
        languages: ["de"],
        showInSelector: true
    },
    {
        id: 6,
        region: "PL",
        defaultLanguage: "pl",
        countryName: "Poland",
        languages: ["pl"],
        showInSelector: true
    },
    {
        id: 7,
        region: "UK",
        defaultLanguage: "en",
        countryName: "United Kingdom",
        languages: ["en"],
        showInSelector: true
    },
    {
        id: 8,
        region: "CA",
        defaultLanguage: "en",
        countryName: "Canada",
        languages: ["en", "fr"],
        showInSelector: true
    },
    {
        id: 9,
        region: "IT",
        defaultLanguage: "it",
        countryName: "Italy",
        languages: ["it"],
        showInSelector: true
    },
    {
        id: 10,
        region: "RU",
        defaultLanguage: "ru",
        countryName: "Russia",
        languages: ["ru"],
        showInSelector: true
    },
    {
        id: 11,
        region: "US",
        defaultLanguage: "en",
        countryName: "USA",
        languages: ["en"],
        showInSelector: true
    },
    {
        id: 12,
        region: "INT",
        defaultLanguage: "en",
        countryName: "Global",
        languages: ["en"],
        showInSelector: true
    }
]

export { locales, localesMap, langselectorItems }